/**
 * @author Gustavo Jimenez <soygus@gmail.com>
 */
import React from "react";
import Next from "../arrow-next.svg";
import Prev from "../arrow-previous.svg";

const ScrollerThumb = () => {
  return (
    <div className="scroller__thumb">
      <img
        src={Prev}
        alt="prev"
        width={24}
        height={24}
        style={{ position: "absolute", fill: "#fff", left: -10 }}
      />
      <img
        src={Next}
        alt="prev"
        width={24}
        height={24}
        style={{ position: "absolute", fill: "#fff", right: -10 }}
      />
    </div>
  );
};

export default ScrollerThumb;
